import {commonmarkLanguage} from '@codemirror/lang-markdown';
import {Language} from "@codemirror/language";
import {Facet} from '@codemirror/state';
import {styleTags, Tag, tags} from '@lezer/highlight';
import {Autolink, Emoji, Strikethrough, Table} from '@lezer/markdown';

import {Keyboard} from '../decoration/keyboard.js';
import {UserMention} from '../decoration/mention.js';
import {Subpage} from "../decoration/subpage.js";

export const subpageTag = Tag.define(tags.meta);
export const keyboardTag = Tag.define(tags.meta);
export const keyboardKeyTag = Tag.define(tags.meta);
export const userMentionTag = Tag.define(tags.meta);
export const horizontalRuleTag = Tag.define(tags.meta);
export const listMarkTag = Tag.define();
export const inlineTag = Tag.define();
export const htmlTag = Tag.define();
export const emojiMark = Tag.define();

const styles = {
  "TableHeader/...": tags.heading,
  'UserMention': userMentionTag,
  'Keyboard': keyboardTag,
  'KeyboardKey': keyboardKeyTag,
  'Subpage': subpageTag,
  "Strikethrough/...": tags.strikethrough,
  'HorizontalRule': horizontalRuleTag,
  'ListMark': listMarkTag,
  'InlineCode/...': inlineTag,
  'HTMLTag HTMLBlock Entity Comment CommentBlock': htmlTag,
  'Emoji': emojiMark,
};

const markdown = commonmarkLanguage.parser.configure([
  Table, UserMention, Keyboard, Subpage, Strikethrough, Autolink, Emoji,
  {props: [styleTags(styles)]}
]);

export default new Language(Facet.define(), markdown);
